import React from "react";
import { Result } from "antd";

function NotFound() {
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#fff",
      }}
    >
      <Result status="404" title="404" subTitle="not found......" />
    </div>
  );
}

export default NotFound;
